module.exports = __webpack_public_path__ + "static/savings-b7a7334bcf7b3e3480d43d2c62d08604.svg";